export const subscriberGroupsTranslation = {

  // section title
  subscriber_groups: 9498,

  // search
  search: 9506,
  search_hits: 9505,
  search_no_subscriber_groups: 9509,

  // messages
  no_access_to_subscriber_groups: 9507,
  subscriber_group_deleted: 9508,
  subscriber_group_updated: 9593,
  subscriber_group_created: 9594,

  // list item
  self_service: 9503,
  user_filter: 9499,
  member_name_filter: 9500,
  member_email_filter: 9501,

  // confirmation
  delete_confirmation: 9510,
  cancel: 9511,

  // prompt unsaved
  cancel_changes: 9512,
  are_you_sure: 9513,
  undo_all: 9514,
  go_back: 9515,

  // form messages
  subscriber_group_validation_error: 9516,
  saving_subscriber_group: 9517,
  deleting_subscriber_group: 9518,
  deleted_code_validation: 9659,

  // form header
  new_subscriber_group: 9523,
  save: 9519,
  add_new: 9504,
  delete: 9502,
  delete_subscriber_group: 9520,

  // form tabs
  switch_to_scroll: 9521,
  switch_to_tab: 9522,

  // sections
  name: 9544,
  email: 9540,
  details: 9524,
  descriptions_and_translations: 9525,
  subscriber_groups_title: 9560,
  subscriber_groups_user_members: 9564,
  user_members_title: 9538,
  external_members_title: 9543,
  external_members_info_no_description: 9559,
  external_members_info_with_description: 9610,
  add_external_member: 9562,
  user_members_info_no_description: 9563,
  user_members_info_with_description: 9611,
  self_service_info: 9565,
  merge_subscriber_group_description: 9615,
  merge_subscriber_group_sub_description: 9616,
  merge_subscriber_group_validation_message: 9617,

  // language
  translations_header: 9526,
  show_translations: 9527,
  description: 9528,
  copy_description_to_all: 9529,
  copied_description_to_all: 9530,
  long_description_title: 9531,
  copy_long_description_to_all: 9532,
  copied_long_description_to_all: 9533,
  required_long_description: 9612,

  // validation
  email_error: 9561,
  must_be_filled_out: 9534,
  duplicated_email: 9614,
  done: 9535,
  remove: 9536,
  remove_all: 9537
};

export type SubscriberGroupsTranslation = {
  readonly [T in keyof typeof subscriberGroupsTranslation]: string
};
